module.exports = __webpack_public_path__ + "static/media/startupnews.a65673c8.png";